const hasMessage = (value: unknown): value is { message: unknown } =>
  typeof value === 'object' && value !== null && 'message' in value;

const extractMessage = (value: unknown): string | undefined => {
  if (!hasMessage(value)) {
    return undefined;
  }

  const messageCandidate = value.message;
  if (typeof messageCandidate === 'string') {
    return messageCandidate;
  }

  if (typeof messageCandidate === 'object' && messageCandidate !== null && 'message' in messageCandidate) {
    const nested = (messageCandidate as Record<string, unknown>).message;
    return typeof nested === 'string' ? nested : undefined;
  }

  return undefined;
};

export function resolveErrorMessage(
  error: unknown,
  language: string,
  fallbackFr: string,
  fallbackEn: string
): string {
  const fallback = language === 'fr' ? fallbackFr : fallbackEn;

  if (!error) {
    return fallback;
  }

  if (typeof error === 'string') {
    const normalized = error.trim();
    return normalized.length > 0 ? normalized : fallback;
  }

  const message = extractMessage(error);
  if (typeof message === 'string') {
    const normalized = message.trim();
    if (normalized.length > 0) {
      return normalized;
    }
  }

  return fallback;
}
